import PropTypes from 'prop-types';
import { Field } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1, 0)
  },
  label: {
    marginBottom: theme.spacing(1)
  }
}));

const FileField = (props) => {
  const { name, label, disabled, touched, helperText: fieldHelperText, ...otherProps } = props;
  const classes = useStyles();
  return (
    <Field name={name}>
      {({ field, form }) => {
        const helperText =
          ((touched || form.touched[field.name]) && form.errors[field.name]) ||
          fieldHelperText;
        const error = (touched || form.touched[name]) && Boolean(form.errors[name]);
        return (
          <FormControl
            component="fieldset"
            error={error}
            className={classes.formControl}
          >
            {label && <FormLabel component="legend" className={classes.label}>{label}</FormLabel>}
            <Input
              id={name}
              type="file"
              filename={field.value}
              onChange={(e) => {
                const {
                  target: {
                    validity,
                    files: [file]
                  }
                } = e;
                form.setFieldValue(name, validity.valid ? file : null);
                form.setFieldTouched(name, true);
              }}
              error={error}
              disabled={disabled}
              className={classes.field}
              disableUnderline
              {...otherProps}
            />
            {helperText && (
              <FormHelperText>{helperText}</FormHelperText>
            )}
          </FormControl>
        );
      }}
    </Field>
  );
};

FileField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  touched: PropTypes.bool,
  helperText: PropTypes.node
};

export default FileField;
